const initGiftMegaMenu = () => {
  const giftMegaMenuTrigger = document.querySelector('[data-gift-mega-menu]');
  const giftMegaMenuElement = document.getElementById('gift-mega-menu');

  if(giftMegaMenuTrigger && giftMegaMenuElement){
    let hoverTimeout;

    // Function to show mega menu
    const showMegaMenu = () => {
      clearTimeout(hoverTimeout);
      giftMegaMenuElement.classList.remove('hidden');
      giftMegaMenuTrigger.setAttribute('aria-expanded', 'true');
      // Use requestAnimationFrame to ensure the element is rendered before adding the show class
      requestAnimationFrame(() => {
        giftMegaMenuElement.classList.add('show');
      });
    };

    // Function to hide mega menu
    const hideMegaMenu = () => {
      giftMegaMenuElement.classList.remove('show');
      giftMegaMenuTrigger.setAttribute('aria-expanded', 'false');
      // Wait for transition to complete before hiding
      hoverTimeout = setTimeout(() => {
        giftMegaMenuElement.classList.add('hidden');
      }, 300); // Match the CSS transition duration
    };

    // Always use hover behavior (no click behavior)
    giftMegaMenuTrigger.addEventListener('mouseenter', showMegaMenu);

    // Hide mega menu when leaving trigger (with delay)
    giftMegaMenuTrigger.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(hideMegaMenu, 200); // Small delay to allow moving to mega menu
    });

    // Keep mega menu visible when hovering over it
    giftMegaMenuElement.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
    });

    // Hide mega menu when leaving the mega menu itself
    giftMegaMenuElement.addEventListener('mouseleave', hideMegaMenu);

    // Handle keyboard accessibility (focus only, no click behavior)
    giftMegaMenuTrigger.addEventListener('focus', showMegaMenu);
    giftMegaMenuTrigger.addEventListener('blur', () => {
      // Only hide if focus is not moving to mega menu content
      setTimeout(() => {
        if (!giftMegaMenuElement.contains(document.activeElement)) {
          hideMegaMenu();
        }
      }, 50);
    });
  }
}

export { initGiftMegaMenu };
